// Desktop Section - Desktop-specific settings and configuration
// Only accessible when running in Revolt Desktop application
// Follows the Section, Component & Manager System architecture

import React, { useEffect } from 'react';
import { MainLayout } from '../../components/Layout';
import { DesktopManager } from './managers/desktop-manager';
import { useManager } from '../../core';
import { logger } from '../../core';
import { DesktopSettingsCard, DesktopHeader } from './components';
import './DesktopSection.css';

// Check if we're running in desktop environment
const isDesktopEnvironment = () => {
  return typeof window !== 'undefined' && !!window.navigationAPI;
};

export function DesktopSection() {
  const { manager, isInitialized } = useManager(DesktopManager);

  // Redirect to home if not in desktop environment
  useEffect(() => {
    if (typeof window !== 'undefined' && !isDesktopEnvironment()) {
      logger.warn({
        tags: 'section|desktop|access',
        color1: 'yellow'
      }, 'Desktop section accessed from non-desktop environment, redirecting to home');

      // Use window.location for immediate redirect
      window.location.href = '/';
    }
  }, []);


  // Don't render anything if not in desktop environment
  if (!isDesktopEnvironment()) {
    return (
      <MainLayout>
        <div className="desktop-access-denied">
          <div className="desktop-access-content">
            <h2>Desktop Only</h2>
            <p>This section is only available in the Revolt Desktop application.</p>
            <p>Please download and use the desktop app to access these settings.</p>
          </div>
        </div>
      </MainLayout>
    );
  }

  // Don't render until manager is initialized
  if (!isInitialized) {
    return (
      <MainLayout>
        <div className="desktop-loading">
          <div>Loading desktop settings...</div>
        </div>
      </MainLayout>
    );
  }

  logger.log({
    tags: "section|desktop|render",
    color1: "lime"
  }, "DesktopSection rendering");

  return (
    <div className="desktop-layout">
      {/* Full-width desktop header below main header */}
      <DesktopHeader activePage="settings" />

      {/* Main content with layout */}
      <MainLayout contentClassName="main-content--desktop">
        <div className="desktop-container">
          <div className="desktop-content">
            <div className="desktop-page-header">
              <h1 className="desktop-title">Desktop Settings</h1>
              <p className="desktop-subtitle">
                Configure how Revolt Desktop behaves on your system
              </p>
            </div>

            <div className="desktop-main-content">
              <DesktopSettingsCard manager={manager} />
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
}
